import React from "react";
import { motion } from "framer-motion";
import { Banknote, Coins, Globe, Headphones, ScrollText, Shield } from "lucide-react";

const ITEMS = [
  { Icon: Banknote, title: "بدون نیاز به حساب خارجی", text: "برای انتشار موزیک و دریافت درآمد، نیازی به حساب بانکی بین‌المللی یا پیچیدگی‌های پرداخت خارجی ندارید." },
  { Icon: Coins, title: "تسویه درآمد در ایران", text: "درآمد ارزی شما پس از دریافت از پلتفرم‌ها، در ایران و با بالاترین نرخ ارز قابل پرداخت تسویه می‌شود." },
  { Icon: Globe, title: "پوشش پلتفرم‌های جهانی", text: "آثار شما در سرویس‌های معتبر موسیقی و ویدیویی بین‌المللی منتشر می‌شود." },
  { Icon: Headphones, title: "پشتیبانی دائمی و رایگان", text: "تیم پشتیبانی فارسی‌زبان ما به‌صورت همیشگی و کاملاً رایگان همراه شماست؛ از لحظه آماده‌سازی اثر تا انتشار، گزارش درآمد و تسویه، هر زمان نیاز داشتید پاسخگوی شما هستیم." },
  { Icon: ScrollText, title: "شفافیت در کارمزد", text: "کارمزد نقد کردن درآمد کاملاً مشخص است: ۲۵ درصد از درآمد دریافتی." },
  { Icon: Shield, title: "حفظ مالکیت اثر", text: "تمرکز ما روی انتشار، مدیریت درآمد و حفاظت از حقوق اثر است؛ مالکیت هنری اثر متعلق به صاحب اثر باقی می‌ماند." },
];

export default function WhyUs() {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            چرا هنرمندان <span className="gradient-text-neon">با ما</span> کار می‌کنند؟
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="glass glass-hover rounded-3xl p-7 group transition-all"
              data-testid={`why-card-${i}`}
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 rounded-xl bg-white/[0.04] border border-white/10 flex items-center justify-center">
                  <it.Icon className="w-5 h-5 text-purple-200" strokeWidth={1.6} />
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">{it.title}</h3>
                  <p className="text-sm text-slate-300 leading-relaxed">{it.text}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
